import axios from "axios";
import config from "@/config";
import SessionUtil from "@/utils/SessionUtil";
import moment from "moment";
import {showDialog, showToast} from "vant";
import CommonUtil from "@/utils/CommonUtil";

export default {
    getOrders() {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/designated-driving/list', {
                headers: {}
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, orders: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getStatus() {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/designated-driving/status', {
                headers: {},
                params: {
                    coordinateType: "GCJ02",
                },
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, status: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    cancel(order_number) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/designated-driving/cancel', null, {
                headers: {},
                params: {
                    order_number: order_number
                },
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, code: rs.code});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    publish(orderData) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/designated-driving/publish', orderData, {
                headers: {},
                params: {},
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, code: rs.code});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
}